var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmazon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 89 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#fff}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g923",
    transform: "translate(-.534 -18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path844",
    d: "M59.7 40.5c-.6.4-1.5.7-2.6.7-1.7 0-3.3-.2-4.9-.7-.4-.1-.7-.2-.9-.2-.3 0-.4.2-.4.6v1c0 .3.1.5.2.7.1.1.3.3.6.4 1.6.7 3.4 1 5.4 1 2.1 0 3.7-.5 5-1.5s1.9-2.3 1.9-4c0-1.2-.3-2.1-.9-2.9-.6-.7-1.6-1.4-3-1.9l-2.8-1.1c-1.1-.4-1.9-.8-2.2-1.2-.4-.4-.6-.8-.6-1.5 0-1.5 1.1-2.3 3.4-2.3 1.3 0 2.6.2 3.8.6.4.1.7.2.8.2.3 0 .5-.2.5-.6v-1c0-.3-.1-.5-.2-.7s-.3-.3-.6-.4c-1.5-.5-3-.8-4.5-.8-1.9 0-3.5.5-4.7 1.4s-1.8 2.2-1.8 3.7c0 2.3 1.3 4 3.9 5l3 1.1c1 .4 1.6.7 2 1.1s.5.8.5 1.4c0 .8-.3 1.5-.9 1.9",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path855",
    d: "M44 26.1v13.3c-1.7 1.1-3.4 1.7-5.1 1.7q-1.65 0-2.4-.9c-.75-.9-.7-1.5-.7-2.8V26.1c0-.5-.2-.7-.7-.7H33c-.5 0-.7.2-.7.7v12.4c0 1.7.4 3.1 1.3 4s2.2 1.4 3.9 1.4c2.3 0 4.6-.8 6.8-2.4l.2 1.2c0 .3.1.4.3.5.1.1.3.1.6.1h1.5c.5 0 .7-.2.7-.7V26.1c0-.5-.2-.7-.7-.7h-2.1c-.6 0-.8.3-.8.7",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path866",
    d: "M25 43.4h2.1c.5 0 .7-.2.7-.7V30.2c0-1.7-.4-3-1.3-3.9s-2.1-1.4-3.8-1.4c-2.3 0-4.7.8-7 2.5-.8-1.7-2.3-2.5-4.5-2.5s-4.4.8-6.6 2.3l-.2-1.1c0-.3-.1-.4-.3-.5-.1-.1-.3-.1-.5-.1H2c-.5 0-.7.2-.7.7v16.6c0 .5.2.7.7.7h2.1c.5 0 .7-.2.7-.7V29.3c1.7-1 3.4-1.6 5.2-1.6q1.5 0 2.1.9c.4.6.7 1.4.7 2.6v11.5c0 .5.2.7.7.7h2.1c.5 0 .7-.2.7-.7V29.3c1.8-1.1 3.5-1.6 5.2-1.6q1.5 0 2.1.9c.6.9.7 1.4.7 2.6v11.5c0 .5.2.7.7.7",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path877",
    d: "M79.5 56.7c-10.9 4.6-22.8 6.9-33.6 6.9-16 0-31.5-4.4-44-11.7-.2-.1-.4-.2-.6-.2-.7 0-1.1.8-.4 1.5 11.6 10.5 27 16.8 44 16.8 12.2 0 26.3-3.8 36-11 1.7-1.2.3-3-1.4-2.3",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path888",
    d: "M79.2 29.4c.9-1 2.3-1.5 4.3-1.5 1 0 2 .1 2.9.4.3.1.4.1.6.1.3 0 .5-.2.5-.7v-1c0-.3-.1-.6-.2-.7s-.3-.3-.5-.4c-1.3-.3-2.6-.6-3.8-.6-2.8 0-4.9.8-6.5 2.5-1.5 1.6-2.3 4-2.3 7s.7 5.3 2.2 6.9 3.6 2.4 6.4 2.4c1.5 0 2.9-.2 4-.7.3-.1.5-.2.6-.4.1-.1.1-.4.1-.7v-1c0-.5-.2-.7-.5-.7-.1 0-.3 0-.5.1-1.1.3-2.2.5-3.2.5q-2.85 0-4.2-1.5c-.9-1-1.3-2.6-1.3-4.7v-.5c.1-2.2.5-3.8 1.4-4.8",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path899",
    d: "M83.7 66.1c5.2-4.4 6.6-13.5 5.5-14.9-.5-.6-2.9-1.2-5.9-1.2-3.2 0-7 .7-9.9 2.7-.9.6-.7 1.4.2 1.3 3.1-.4 10.1-1.2 11.4.4 1.2 1.6-1.4 8.2-2.6 11.1-.3.9.4 1.2 1.3.6",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path910",
    d: "M69.8 25.4h-2.1c-.5 0-.7.2-.7.7v16.6c0 .5.2.7.7.7h2.1c.5 0 .7-.2.7-.7V26.1c0-.4-.2-.7-.7-.7",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path921",
    d: "M70.4 18.6c-.4-.4-1-.6-1.7-.6s-1.2.2-1.6.6-.6.9-.6 1.5.2 1.2.6 1.5c.4.4.9.6 1.6.6s1.2-.2 1.6-.6.6-.9.6-1.5-.1-1.2-.5-1.5",
    className: "st0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazon);
export default __webpack_public_path__ + "static/media/amazon.e31b341452d50e4d50cefe0f614ee5c4.svg";
export { ForwardRef as ReactComponent };